<div class="task-view__scroll" #scroll (scroll)="onScroll()">
  <div class="task-view__panel">
    <ux-avatar-select
      [projectId]="task().projectId"
      [user]="task().responsible?.user"
      [popupStyle]="{ top: '0', 'left.px': '45' }"
      [value]="task().responsibleId"
      (remove)="onChangeResponsible(null)"
      (select)="onChangeResponsible($event)"
      class="task-view__avatar"
    >
    </ux-avatar-select>
    <span class="task-view__control" [class.task-view__control_active]="task()?.isComplete" (click)="onComplete()">
      <i class="icon-ok"></i>
    </span>
    <span
      class="task-view__control"
      (click)="onOpenCalendarPopup($event)"
      [ngClass]="{
        'task-view__control_active': isOpenCalendarPopup() || task().deadlineAt,
      }"
    >
      <i class="icon-calendar" [ngClass]="task().getDeadlineCssClass()"></i>
    </span>
    <!--<span class="task-view__control">-->
    <!--<i class="icon-like task-view__like" count="10"></i>-->
    <!--</span>-->
    <!--<span class="task-view__control">-->
    <!--<i class="icon-check-list"></i>-->
    <!--</span>-->
    <span class="task-view__control task-view__control_file">
      <input
        #inputUploadFiles
        type="file"
        [multiple]="true"
        (change)="onFileUpload($event.target)"
        accept=".pdf,.doc,.docx,.zip,.rar,.png,.jpeg,.jpg,.txt,.csv,.xls,.xlsx,.ppt,.pptx,.webp,.gif,.svg,.mp4,.mp3,.avi,.mov,.json,.xml,.7z,.tar,.gz"
      />
      <i class="icon-add"></i>
    </span>
    <span class="task-view__control" [class.task-view__control_active]="task()?.isFavorite" (click)="onFavorite()">
      <i class="icon-star"></i>
    </span>

    @if (isOpenArchivePopup()) {
      <app-task-view-archive-popup
        (clickOutside)="onCloseArchivePopup()"
        [delayClickOutsideInit]="true"
        [task]="task()"
        class="task-view__archive-popup"
        (onClose)="onClose()"
      >
      </app-task-view-archive-popup>
    }
  </div>
  <div class="task-view__content-wrapper">
    <div class="task-view__content">
      <div class="task-view__header">
        <div class="task-view__status">
          <ux-status
            class="task-view__status-name"
            [status]="task().status"
            (click)="onOpenStatusPopup($event)"
          ></ux-status>
          @if (isOpenStatusPopup()) {
            <ux-popup-status
              class="task-view__status-popup"
              [value]="task().statusId"
              [projectId]="task().projectId"
              (onClose)="onCloseStatusPopup()"
              (selectItem)="onChangeStatus($event)"
              (clickOutside)="onCloseStatusPopup()"
              [delayClickOutsideInit]="true"
            >
            </ux-popup-status>
          }
        </div>
        <div class="task-view__right">
          <i class="icon-close task-view__close" (click)="onClose()"></i>
        </div>
      </div>

      <textarea
        autosize
        rows="1"
        class="task-view__title"
        placeholder="Название задачи"
        [formControl]="nameControl"
        (keydown.enter)="onSaveName()"
        (blur)="onSaveName()"
      >
      </textarea>

      @if (task().deadlineAt) {
        <div class="task-view__deadline" (click)="onOpenCalendarPopup($event)" [ngClass]="task().getDeadlineCssClass()">
          <span class="task-view__deadline-label"
            >Срок выполнения:
            <span class="task-view__deadline-value">{{ task().deadlineAt | date: 'd MMM' }}</span></span
          >
        </div>
      }
      @if (isOpenCalendarPopup()) {
        <ux-calendar
          class="task-view__calendar"
          [selectedDate]="task().deadlineAt"
          (clearDate)="onClearDeadline()"
          (changeDate)="onChangeDeadline($event)"
          (clickOutside)="onCloseCalendarPopup()"
          [delayClickOutsideInit]="true"
        >
        </ux-calendar>
      }

      <div class="task-view__task">
        <app-editor
          #editor
          [data]="editorData()"
          (dataChanged)="onEditorDataChanged($event)"
          (focus)="onEditorFocus()"
          (blur)="onEditorBlur()"
          [imageUploadCallback]="handleImageUpload"
        ></app-editor>
        <div class="task-view__save-bar">
          <button
            type="button"
            class="button button_plr11 button_green task-view__save-btn"
            [disabled]="!isDirty()"
            (click)="onSaveTask()"
          >
            {{ isDirty() ? 'Сохранить' : 'Сохранено' }}
          </button>
        </div>
      </div>

      @if (isOpenSavePopup()) {
        <div class="task-view__save-popup-overlay">
          <div class="task-view__save-popup">
            <div class="task-view__save-popup-title">Несохранённые изменения</div>
            <div class="task-view__save-popup-text">
              У вас есть несохранённые изменения. Сохранить их перед выходом?
            </div>
            <div class="task-view__save-popup-actions">
              <button
                type="button"
                class="button button_plr11 task-view__save-popup-cancel"
                (click)="onCancelSavePopup()"
              >
                Отмена
              </button>
              <button
                type="button"
                class="button button_plr11 button_green"
                (click)="onConfirmSavePopup()"
              >
                Сохранить
              </button>
            </div>
          </div>
        </div>
      }

      <app-task-view-tag
        [tags]="task().tags"
        [availabletagList]="task().tagList"
        [projectId]="task().projectId"
        (onChangeTags)="onChangeTags($event)"
        class="task-view__tag"
      ></app-task-view-tag>
      <!--<app-task-view-check-list class="task-view__check-list"></app-task-view-check-list>-->
      @if (task().files.length) {
        <app-task-view-files
          [files]="task().files"
          [loadingFiles]="files()"
          (onFileUpload)="onFileUpload($event)"
          (onFileDelete)="onDeleteFile($event)"
          class="task-view__files"
        >
        </app-task-view-files>
      }

      <app-task-view-comments
        class="task-view__comments"
        [taskId]="task().id"
        [newMessageSubject]="newMessageSubject$"
        (newMessageEmitter)="scrollToBottom()"
      ></app-task-view-comments>
      <div id="bottom-anchor" #scrollEnd></div>
    </div>
    @if (task().id) {
      <div class="task-view__footer">
        <div class="task-view__footer-container">
          <app-task-view-comments-form
            class="task-view__comments-form"
            [task]="task()"
            [newMessageSubject$]="newMessageSubject$"
          ></app-task-view-comments-form>
          <app-task-view-followers
            class="task-view__followers"
            [task]="task()"
            (onSave)="onUpdateFollowers($event)"
          ></app-task-view-followers>
        </div>
      </div>
    }
  </div>
</div>
